module.exports = __webpack_public_path__ + "static/img/pic_gz@2x.5cf7412f.png";